import React from 'react';
import LandingPreviewBlock from '@/components/LandingPreviewBlock';
import TenantFooter from '@/components/TenantFooter';

// Institutional landing screen shown BEFORE the report form, only for tenants
// that opted into `layout_style: 'whistlelink_style'`. Classic tenants (incl.
// demo, whose layout_style is always 'classic') never render this.
export const WhistlelinkLanding = ({ tenant, branding, onStart }) => (
  <div className="min-h-screen">
    <LandingPreviewBlock
      tenantName={tenant.name}
      heroTitle={branding?.hero_title}
      heroSubtitle={branding?.hero_subtitle}
      heroImageUrl={branding?.hero_image_url}
      primaryColor={branding?.primary_color}
      logoUrl={branding?.company_logo_url || branding?.logo_url}
      institutionalText={branding?.institutional_text}
      supportEmail={branding?.support_email}
      supportSignature={branding?.support_signature}
      onStart={onStart}
      interactive
      sticky
    />
    <TenantFooter branding={branding} />
  </div>
);
